export default __webpack_public_path__ + "40267127144badae53d1b88cf7e93c62.svg";